<!-- wireframe -->
<div class="wrapper" *ngIf="ifloaded">
    <div class="wrapper-body create-appointment">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-header d-flex align-items-center">
                        <h3>Create Appointment</h3>
                        <a routerLink="/dashboard" class="ml-auto grey theme-button">Go Back</a>
                    </div>
                </div>
            </div>

            <!-- Intake Form -->
            <form id="intakeForm" class="custom-form" [formGroup]="AppointmentForm" autocomplete="off">

                <!-- Existing Client -->
                <!-- <div class="existing mb-3">
                    <div class="row">
                        <div class="col-md-4 col-lg-3">
                            <div class="d-flex align-items-center">
                                <p>Is this an exisiting client</p>
                                <select id="existingClient" class="ml-2">
                                    <option value="yes">Yes</option>
                                    <option value="no" selected>No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- Appointment Details -->
                <div class="row">
                    <div class="col-12">
                        <div class="card light">
                            <div class="row">
                                <div class="col-12">
                                    <h5>Preferred Location & Date</h5>
                                </div>
                            <!-- Choose Testing Location Dropdown -->
<div class="col-md-3">
    <select (change)="selectLocation()" formControlName="locationId"
            [(ngModel)]="locationId" id="testingLocation"
            [ngClass]="{ 'border border-danger ': !diagAvailable }">
      <option value="" selected disabled>Choose Testing Location</option>
      <option *ngFor="let city of locations.data" [ngValue]="city.id">{{city.name}}</option>
    </select>
    <!-- Custom Validation Message -->
    <div *ngIf="!diagAvailable" class="text-danger">
      No Diagnostician for this location
    </div>
  </div>
  
  
                                <div class="col-md-3">

                                    <input type="text"
                                        [ngClass]="{ 'pointer-disable': modalDisabled} "
                                        placeholder="Assessment Date" id="assessmentDate"
                                        formControlName="appointmentDate" [ngModel]="assessmentDate" data-toggle="modal"
                                        data-target="#schedulerModal" autocomplete="off" readonly>
                                   
                                </div>
                                <div class="col-md-3">
                                    <input type="text" [ngClass]="{'pointer-disable' : modalDisabled}"
                                        placeholder="Assessment Time" id="assessmentTime"
                                        formControlName="appointmentTime" [ngModel]="appointmentTime" autocomplete="off"
                                        readonly>
                                </div>
                                <div class="col-md-3">
                                    <select id="assestmentType" formControlName="assesmentId"
                                    [ngClass]="{'border-danger': (af['assesmentId'].touched && af['assesmentId'].invalid)}">
                              <option value="" disabled>Assessment Type</option>                                        
                              <option *ngFor="let i of testTypes" [ngValue]="i.id">
                                            {{i.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <form action="" class="custom-form" [formGroup]="parentDetailsForm">

                <!-- Client Details -->
                <div class="row">
                    <div class="col-12">
                        <div class="card light">
                            <div class="row">
                                <div class="col-12">
                                    <h5>Fill Client Details</h5>
                                </div>
                                <div class="col-md-3">
                                    <input type="text" formControlName="studentFirstName"
                                        placeholder="Client First Name"
                                        [ngClass]="{'border border-danger': f['studentFirstName'].touched && f['studentFirstName'].errors }">
                                </div>
                                <div class="col-md-3">
                                    <input type="text"
                                        [ngClass]="{'border border-danger': f['studentLastName'].touched && f['studentLastName'].errors }"
                                        formControlName="studentLastName" placeholder="Client Last Name">
                                </div>
                                <div class="col-md-3">
                                    <input type="text"  [ngClass]="{'border border-danger': f['grade'].value!='Adult' && f['grade'].value!='College' && f['grade'].value!='' && f['grade'].value.length<=0 || f['parentName'].touched && f['parentName'].errors }"
                                    formControlName="parentName"
                                    placeholder="{{ parentNamePlaceholder }}">
                                </div>
                                <div class="col-md-3">
                                    <input type="text" formControlName="nickName" placeholder="Nickname (Optional)">
                                </div>
                                <div class="col-md-3">
                                    <input type="test"
                                        [ngClass]="{'border border-danger': f['dateOfBirth'].touched && f['dateOfBirth'].errors }"
                                        formControlName="dateOfBirth" placeholder="Date of Birth" min="1950-01-01" max="3000-01-01"
                                        onfocus=" this.type='date',this.max=new Date().toISOString().split('T')[0]">
                                        <!-- Error Message for Future Date -->
                                    <p *ngIf="f['dateOfBirth'].errors?.['futureDate']" class="error-message small text-danger pl-1">
                                        Date of birth cannot be in the future.
                                    </p>    
                                </div>
                                <div class="col-md-2">
                                    <select
                                        [ngClass]="{'border border-danger': f['grade'].touched && f['grade'].errors }"
                                        id="schoolType" formControlName="grade" #grade (change)="onGradeChange(grade.value)">
                                        <option value="" selected disabled>Grade</option>
                                        <option value="Adult">Adult</option>
                                        <option value="College">College</option>
                                        <option value="Kindergarten">Kindergarten</option>
                                        <option value="Grade 1">Grade 1</option>
                                        <option value="Grade 2">Grade 2</option>
                                        <option value="Grade 3">Grade 3</option>
                                        <option value="Grade 4">Grade 4</option>
                                        <option value="Grade 5">Grade 5</option>
                                        <option value="Grade 6">Grade 6</option>
                                        <option value="Grade 7">Grade 7</option>
                                        <option value="Grade 8">Grade 8</option>
                                        <option value="Grade 9">Grade 9</option>
                                        <option value="Grade 10">Grade 10</option>
                                        <option value="Grade 11">Grade 11</option>
                                        <option value="Grade 12">Grade 12</option>
                                    </select>
                                    <!-- <input type="text" formControlName="grade" placeholder="Grade (Optional)"> -->
                                </div>
                                <div class="col-md-3">
                                    <select
                                        [ngClass]="{'border border-danger': f['schoolType'].touched && f['schoolType'].errors }"
                                        id="schoolType" formControlName="schoolType">
                                        <option value="" selected disabled>School Type</option>
                                        <option *ngFor="let i of schoolType">{{i.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-4">
                                    <input type="text" formControlName="school"
                                        placeholder="School/District (Optional)">
                                </div>
                                <div class="col-md-3">
                                    <p-inputMask mask="(999) 999-9999" placeholder="Cell Number" formControlName="cellNumber"
                                    [ngClass]="{'border border-danger': f['cellNumber'].touched && f['cellNumber'].errors }"></p-inputMask>
                                </div>
                                <div class="col-md-3">
                                    <p-inputMask mask="(999) 999-9999" formControlName="phoneNumber" placeholder="Phone Number (Optional)"></p-inputMask>
                                </div>
                                <div class="col-md-3">
                                    <input type="email"
                                        [ngClass]="{'border border-danger': f['emailAddress'].touched && f['emailAddress'].errors }"
                                        formControlName="emailAddress" placeholder="Email Address">
                                </div>
                                <div class="col-md-3">
                                    <input type="email"
                                        [ngClass]="{'border border-danger': f['secondaryEmailAddress'].touched && f['secondaryEmailAddress'].errors }"
                                        formControlName="secondaryEmailAddress"
                                        placeholder="Secondary Email (Optional)">
                                </div>
                                <div class="col-md-3">
                                    <select
                                        [ngClass]="{'border border-danger': f['reasonForCall'].touched && f['reasonForCall'].errors }"
                                        id="reasonForCall" formControlName="reasonForCall">
                                        <option value="" selected disabled>Reason For Call</option>
                                        <option>ADHD/Attention</option>
                                        <option>Math</option>
                                        <option>Reading Comprehension</option>
                                        <option>Dyslexia</option>
                                        <option>Processing Issues</option>
                                        <option>Writing</option>
                                        <option>Dyscalculia</option>
                                        <option>Dysgraphia</option>
                                        <option>Other</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <input type="text"  formControlName="address1"
                                    placeholder="Address 1 (Optional)">
                                </div>
                                <div class="col-md-3">
                                    <input type="text"  formControlName="address2"
                                    placeholder="Address 2 (Optional)">
                                </div>
                                <div class="col-md-3">
                                    <input type="text"  formControlName="city"
                                    placeholder="City (Optional)">
                                </div>
                                <div class="col-md-3">
                                    <input type="text" formControlName="state" placeholder="State (Optional)"
                                           [ngClass]="{'border border-danger': f['state'].touched && f['state'].invalid}">
                                    <div *ngIf="f['state'].touched && f['state'].errors?.['invalidState']" class="text-danger">
                                      <small>State must contain only letters.</small>
                                    </div>
                                  </div>
                                  
                                  <div class="col-md-3">
                                    <input type="text" formControlName="zipCode" placeholder="Zip Code (Optional)">
                                    <div *ngIf="f['zipCode'].touched && f['zipCode'].errors?.['invalidZip']" class="text-danger">
                                        Invalid Zip Code Format.
                                    </div>
                                </div>
                                
                                <div class="col-md-6">
                                    <input type="text" [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="appointmentComments" placeholder="Additional Comments (Optional)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Continue to Payment -->
                <div class="payment mt-0">
                    <div class="row align-items-center">
                        <div class="col-md-4">
                            <div class="card light">
                              <div class="input-group">
                                <div class="input-group-text">$</div>
                                <input class="mb-0" type="number" formControlName="appointmentTestAmount" (input)="checkForInvalidCharacters($event)" placeholder="Test Amount" [ngClass]="{'border border-danger': f['appointmentTestAmount'].touched && f['appointmentTestAmount'].errors }">
                                <!-- Error Message for Non-Numeric Input -->
                                
                                  
                              </div>
                              <div *ngIf="displayErrorMessage" class="text-danger mt-1">
                                {{ displayErrorMessage }}
                              </div>
                              <div *ngIf="f['appointmentTestAmount'].errors?.['maxDigits']" class="text-danger">
                                Maximum of 4 digits allowed.
                              </div>
                            </div>
                          </div>
                          
                        <div class="col-md-8">
                            <button type="button" form="intakeForm" class="theme-button float-md-right"
                            id="intakeFormSubmit" (click)="submitForm()"
                            [ngClass]="{'grey' : parentDetailsForm.controls['grade'].value!='Adult' && parentDetailsForm.controls['grade'].value!='College' && parentDetailsForm.controls['grade'].value!='' && parentDetailsForm.controls['parentName'].value.length<=0 || parentDetailsForm.invalid || AppointmentForm.invalid}"
                            [disabled]=" parentDetailsForm.controls['grade'].value!='Adult' && parentDetailsForm.controls['grade'].value!='College' && parentDetailsForm.controls['grade'].value!='' && parentDetailsForm.controls['parentName'].value.length<=0 || parentDetailsForm.invalid || AppointmentForm.invalid"
                            data-toggle="modal">Continue to Deposit</button>
                    
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>




<!-- payment module -->


<!-- Modal -->
<!-- Payment Modal -->
<div class="modal fade" id="paymentModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="paymentModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content text-center light px-5 py-4">
            <h4>Booking Payment</h4>
            <p class="mb-0">Enter booking amount in below input field</p>
            <!-- <p class="text-black">Test Amount : <span class="text-green"><b>{{testAmount}}</b></span></p> -->
            <form [formGroup]="paymentDepositForm">
            <input type="number" placeholder="Enter Amount" formControlName="paymentAmount" id="bookingDeposit"
                class="custom-input mt-3"  required>
                <div *ngIf="pf['paymentAmount'].errors?.['maxDigits']" class="text-danger">
                    Maximum of 4 digits allowed.
                  </div>
                </form>
            <div class="action">
                <a href="https://app.fluidpay.com/auth"  
                target="_blank" 
                class="theme-button green mx-2">
                    Payment Link
                </a>
                <button class="theme-button mx-2" data-dismiss="modal" data-toggle="modal"
                    [ngClass]="{'grey' :pf['paymentAmount'].value==undefined || pf['paymentAmount'].value > testAmount || pf['paymentAmount'].value<0 ||pf['paymentAmount'].invalid}"
                    [disabled]="pf['paymentAmount'].value==undefined || pf['paymentAmount'].value > testAmount || pf['paymentAmount'].value<0 ||pf['paymentAmount'].invalid" (click)="submitPayment()">Collect
                    Deposit</button>

            </div>
        </div>
    </div>
</div>

<!-- Appoitment Scheduled -->
<div class="modal fade show" id="appointmentScheduled" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="appointmentScheduled" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <div class="d-flex">
                <div class="icon">
                    <img src="assets/images/logo-icon-tick.svg" width="100" class="img-fluid mr-5">
                </div>
                <div class="content">
                    <h4>Appointment Scheduled!!</h4>
                    <p>Transaction Id:
                        <span>{{paymentResponse.transactionId}}</span>
                    </p>
                    <ul>
                        <li><span>Client Name</span>: {{paymentResponse.clientFirstName}}
                            {{paymentResponse.clientLastName}}</li>
                        <li><span>Appointment Date</span>: {{paymentResponse.appointmentDate}}</li>
                        <li><span>Appointment Time</span>: {{paymentResponse.appointmentTestTime}} </li>
                        <li><span>Diagnostician Name</span>: {{paymentResponse.diagnosticianFirstName}}
                            {{paymentResponse.diagnosticianLastName}}</li>
                        <li><span>Location</span>: {{paymentResponse.locationName}}</li>
                    </ul>
                    <a [routerLink]="['/appt-all-details',appointmentId]" class="theme-button grey" data-dismiss="modal">View Details</a>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Scheduler Modal -->
<div class="modal fade create_appointment-modal" id="schedulerModal" data-keyboard="false" tabindex="-1" aria-labelledby="schedulerModal"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="actions">
                <button class="theme-button grey float-right" (click)="onDeleteClick()"
                    data-dismiss="modal">{{reset}}</button>
                    <a href="javascript:void()" class="theme-button green float-right mr-2"  [class.disabled]="isSaving" data-dismiss="modal">Save</a>
            </div>
            <div class="scheduler mt-2" *ngIf="show">
                <div class="card">
                    <mbsc-eventcalendar invalidateEvent="start-end" [clickToCreate]="clickToCreate"
                        [options]="calendarOptions"   [invalid]="invalid" [view]="view" [data]="myEvents" groupBy="date"
                        [resources]="myResources" [resourceTemplate]="resourceTemp">
                        <ng-template #resourceTemp let-resource>
                            <div class="header-resource-template-content">
                                <div class="header-resource-name" title="{{resource.name}}">
                                    {{resource.name}}
                                  </div>
                               </div>
                          </ng-template>
                    </mbsc-eventcalendar>

                    <mbsc-popup [options]="popupOptions" [anchor]="popupAnchor" [buttons]="popupButtons"
                        [headerText]="popupHeaderText" #popup>
                        <div class="mbsc-form-group">
                            <mbsc-input label="Location" [(ngModel)]="locationName"></mbsc-input>

                            <mbsc-input label="Diagnostician" [(ngModel)]="resourceName"></mbsc-input>
                        </div>
                        <div class="mbsc-form-group">
                            <!-- <mbsc-input [disabled]="true" label="Select Time Slot" labelStyle="floating"></mbsc-input>
                            <p>Current slot: {{ selectTimeSlots }}</p>

                            <mbsc-segmented-group [(ngModel)]="selectTimeSlots">
                                <mbsc-segmented value="slot1">Morning</mbsc-segmented>
                                <mbsc-segmented value="slot2">Afternoon</mbsc-segmented>
                            </mbsc-segmented-group> -->
                            

                            <!-- Start Time -->
                            <!--
                            <mbsc-datepicker [(ngModel)]="popupEventDates" [options]="datePickerOptions"
                                [controls]="datetimePickerControls" [responsive]="datePickerResponsive"
                                [startInput]="endInput"></mbsc-datepicker>
                            <mbsc-input #endInput label="Start Time"></mbsc-input>
                             -->
                            <!-- Start Time -->

                            <div *ngIf="isEdit" class="mbsc-button-group">
                                <mbsc-button class="mbsc-button-block" color="danger" variant="outline"
                                    (click)="onDeleteClick()">Delete event
                                </mbsc-button>
                            </div>
                        </div>
                    </mbsc-popup>
                </div>
            </div>
              <!-- Modal Footer -->
              <!-- <div class="modal-footer">
                <button class="theme-button primary" (click)="setCalendarToToday()">Today</button>
                <button class="theme-button grey" data-dismiss="modal">Close</button>
            </div> -->
        </div>
    </div>
</div>



<div>
    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple">
        <!-- <p style="color: white">Please Wait... </p> -->
    </ngx-spinner>
</div>